import React, { createContext, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Create the context
const AppMenuContext = createContext();

// Create a provider component
export const AppMenuProvider = ({ children }) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState(t('appName')); // Default title

    const updateTitle = newTitle => {
        setTitle(newTitle);
    };

    return (
        <AppMenuContext.Provider value={{ title, updateTitle }}>
            {children}
        </AppMenuContext.Provider>
    );
};

// Custom hook to use the context
export const useAppMenu = () => {
    return useContext(AppMenuContext);
};